import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { MapViewSettingsService } from "src/app/services/mapViewSettings.service";

@Component({
  standalone: false,
    selector: "app-extended-map-options",
    templateUrl: "./extended-map-options.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./extended-map-options.component.scss"],
})
export class ExtendedMapOptionsComponent implements OnInit {
    @ViewChild("mapOptions") mapOptions: ElementRef;

    @Output() showNodesEvent = new EventEmitter<boolean>();
    @Output() showWindDirEvent = new EventEmitter<boolean>();
    @Output() zoneRiskType = new EventEmitter<string>();
    @Output() showAirNowSensorsEvent = new EventEmitter<boolean>();

    showOptions = false;
    displayNodes = true;
    displayWindDirection = true;
    isDust: boolean;
    isZonedRisk: boolean;
    displayAirNowSensorsData: boolean;

    constructor(private mapViewSettingsService: MapViewSettingsService) {}

    ngOnInit(): void {
        this.restoreSettings();
    }

    /**
     * Restore map view settings from localStorage
     */
    private restoreSettings(): void {
        const settings = this.mapViewSettingsService.getSettings();
        this.displayNodes = settings.showNodes;
        this.displayWindDirection = settings.showWindCones;
        this.displayAirNowSensorsData = settings.showAirNowSensors;
        this.isDust = settings.riskType === "Dust Map";
        this.isZonedRisk = settings.riskType === "Zoned Risk Map";

        // Emit events to update parent components
        this.showNodesEvent.emit(this.displayNodes);
        this.showWindDirEvent.emit(this.displayWindDirection);
        this.showAirNowSensorsEvent.emit(this.displayAirNowSensorsData);
        if (this.isZonedRisk) {
            this.zoneRiskType.emit("Zoned Risk Map");
        }
    }

    toggleOptionDisplay() {
        const optionsRef = document.getElementById("extendedMapOptions");
        this.showOptions = !this.showOptions;
        this.showOptions
            ? optionsRef.classList.add("displayed")
            : optionsRef.classList.remove("displayed");
    }

    showNodes() {
        this.displayNodes = !this.displayNodes;
        this.mapViewSettingsService.updateSetting("showNodes", this.displayNodes);
        this.showNodesEvent.emit(this.displayNodes);
    }

    selectRiskType(riskType: string = "Dust Map") {
        this.isDust = riskType == "Dust Map";
        this.isZonedRisk = riskType == "Zoned Risk Map";
        const dustRef = document.getElementById("dustOption");
        const zoneRiskRef = document.getElementById("zoneRiskOption");
        if (this.isDust) {
            dustRef.classList.add("selected");
            zoneRiskRef.classList.remove("selected");
        } else {
            zoneRiskRef.classList.add("selected");
            dustRef.classList.remove("selected");
        }
        this.mapViewSettingsService.updateSetting("riskType", riskType);
        this.zoneRiskType.emit(riskType);
        this.toggleOptionDisplay();
    }

    showWindData() {
        this.displayWindDirection = !this.displayWindDirection;
        this.mapViewSettingsService.updateSetting("showWindCones", this.displayWindDirection);
        this.showWindDirEvent.emit(this.displayWindDirection);
    }

    showAirNowSensorsData() {
        this.displayAirNowSensorsData = !this.displayAirNowSensorsData;
        this.mapViewSettingsService.updateSetting(
            "showAirNowSensors",
            this.displayAirNowSensorsData,
        );
        this.showAirNowSensorsEvent.emit(this.displayAirNowSensorsData);
    }
}
